import { render } from "./Index.vue?vue&type=template&id=12460d38&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=12460d38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12460d38"

export default script